import { render, staticRenderFns } from "./ExchangeCardMolecule.vue?vue&type=template&id=8a7432d0&"
import script from "./ExchangeCardMolecule.vue?vue&type=script&lang=ts&"
export * from "./ExchangeCardMolecule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports